var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { DragDropContext } from "react-beautiful-dnd";
var TableWrapper = function (_a) {
    var draggableRowsOptions = _a.draggableRowsOptions, setDraggingRowIndex = _a.setDraggingRowIndex, children = _a.children;
    if (!draggableRowsOptions) {
        return (_jsx(_Fragment, { children: children }));
    }
    return (_jsx(DragDropContext, __assign({ onDragEnd: function (result, provided) {
            draggableRowsOptions === null || draggableRowsOptions === void 0 ? void 0 : draggableRowsOptions.onDragEnd(result, provided);
            setDraggingRowIndex(undefined);
        }, onBeforeDragStart: function (start) { return setDraggingRowIndex(start.source.index); } }, { children: children })));
};
export default TableWrapper;
